import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import e3logo from "../assets/e3logo.png";
import { useTheme } from "@mui/material/styles";

function SignUpPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const [userData, setUserData] = useState({
    name: "",
    username: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    console.log("Sign up submitted");

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "/api/auth/signup",
        {
          name: userData.name,
          username: userData.username,
          password: userData.password,
        }
      );
      console.log("Response:", response.data);
      console.log("Sign-up successful");
      navigate("/login");
    } catch (error) {
      console.error("Error during sign-up", error);
    }
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen"
      style={{
        backgroundColor: isDarkMode ? "#282A36" : "#f9fafb",
      }}
    >
      <div
        className="w-96 rounded-lg p-6 shadow-md text-center"
        style={{
          backgroundColor: isDarkMode ? "#1E1F29" : "white",
          color: isDarkMode ? "#F8F8F2" : "black",
        }}
      >
        {/* Company logo */}
        <img src={e3logo} alt="E3 Company Logo" className="w-20 mx-auto mb-4" />

        {/* Title */}
        <h2 className="text-2xl font-bold mb-2">Create your account</h2>
        <p
          className="mb-4"
          style={{ color: isDarkMode ? "#BD93F9" : "#4B5563" }}
        >
          Welcome! Please enter your details to create an account!.
        </p>

        {/* Tabs */}
        <div
          className="flex border rounded-lg overflow-hidden mb-4"
          style={{
            borderColor: isDarkMode ? "#6272A4" : "#D1D5DB",
          }}
        >
          <Link
            to="/signup"
            className="flex-1 py-2 font-medium"
            style={{
              backgroundColor: isDarkMode ? "#282A36" : "white",
              color: isDarkMode ? "#F8F8F2" : "black",
            }}
          >
            Sign up
          </Link>
          <Link
            to="/login"
            className="flex-1 py-2 font-medium hover:bg-gray-200"
            style={{
              backgroundColor: isDarkMode ? "#44475A" : "#f3f4f6",
              color: isDarkMode ? "#F8F8F2" : "#374151",
            }}
          >
            Log in
          </Link>
        </div>

        {/* Form */}
        <form onSubmit={handleSignUp} className="text-left space-y-4">
          <div>
            <label className="block font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={userData.name}
              onChange={handleInputChange}
              placeholder="Enter Name"
              className="w-full p-2 rounded-md focus:ring"
              style={{
                backgroundColor: isDarkMode ? "#44475A" : "white",
                border: `1px solid ${isDarkMode ? "#6272A4" : "#D1D5DB"}`,
                color: isDarkMode ? "#F8F8F2" : "black",
              }}
              required
            />
          </div>
          <div>
            <label className="block font-medium">Username (Email)</label>
            <input
              type="username"
              name="username"
              value={userData.username}
              onChange={handleInputChange}
              placeholder="Username (Email)"
              className="w-full p-2 rounded-md focus:ring"
              style={{
                backgroundColor: isDarkMode ? "#44475A" : "white",
                border: `1px solid ${isDarkMode ? "#6272A4" : "#D1D5DB"}`,
                color: isDarkMode ? "#F8F8F2" : "black",
              }}
              required
            />
          </div>
          <div>
            <label className="block font-medium">Password</label>
            <input
              type="password"
              name="password"
              value={userData.password}
              onChange={handleInputChange}
              placeholder="Create Password"
              className="w-full p-2 rounded-md focus:ring"
              style={{
                backgroundColor: isDarkMode ? "#44475A" : "white",
                border: `1px solid ${isDarkMode ? "#6272A4" : "#D1D5DB"}`,
                color: isDarkMode ? "#F8F8F2" : "black",
              }}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 rounded-md"
            style={{
              backgroundColor: isDarkMode ? "#22C55E" : "#22C55E",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Sign up
          </button>
        </form>

        <button
          className="w-full border py-2 rounded-md"
          style={{
            backgroundColor: isDarkMode ? "#44475A" : "white",
            color: isDarkMode ? "#F8F8F2" : "black",
            borderColor: isDarkMode ? "#6272A4" : "#D1D5DB",
          }}
        >
          Continue with SSO
        </button>

        <p className="mt-4 text-sm">
          Already have an account?{" "}
          <Link
            to="/login"
            className="hover:underline"
            style={{
              color: isDarkMode ? "#BD93F9" : "#3B82F6",
            }}
          >
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default SignUpPage;
